export enum BeneficiariesFieldOrdination {
	CREATION_DATE = 'creation_date',
	EXCLUSION_DATE = 'exclusion-date',
	INACTIVATION_DATE = 'inactivation_date',
	NAME = 'name',
	SCHEDULED_DATE = 'scheduledDate',
}
